import { initSwiperCarousel } from '~/components/SwiperCarousel';
import { retryAjax } from './HomeSearch';

declare const BaseUrlWeb: string;

const isMobile: boolean = window.matchMedia('(pointer: coarse)').matches;

/**
 * Inizializza lo swiper delle vendite in evidenza dopo il caricamento AJAX.
 */
function inizilaizzaEvidenzaSwiper(): void {
    initSwiperCarousel('.swiperEvidenzeSlideHpDesktop', {
        base: 1.5, bp480: 1.5, bp576: 2, bp768: 2.5, bp992: 3, bp1200: 4, bp1400: 4,
    });
}

/**
 * Effettua la chiamata AJAX per le vendite in evidenza.
 */
async function callAjaxVenditeInEvidenza(slideType: string): Promise<string> {
    console.log(`callAjaxVenditeInEvidenza - slideType: ${slideType}`);
    const url = BaseUrlWeb + 'Home/_VenditeInEvidenza';
    const options = { type: 'GET', url, data: { slideType } };

    try {
        return await retryAjax<string>(options);
    } catch (error) {
        console.error('Errore nella chiamata AJAX:', error);
        throw error;
    }
}

/**
 * Carica le vendite in evidenza nel contenitore specificato.
 */
async function loadVenditeInEvidenza(slideType: string): Promise<void> {
    try {
        const data = await callAjaxVenditeInEvidenza(slideType);
        $('#venditeInEvidenzaContainer').html(data);
        if (!isMobile) {
            inizilaizzaEvidenzaSwiper();
        }
    } catch (error) {
        console.error('Errore nel caricamento delle vendite in evidenza:', error);
    }
}

/**
 * Effettua la chiamata AJAX per la fascia home.
 */
async function callAjaxFasciaHome(slideType: string): Promise<string> {
    console.log(`callAjaxFasciaHome - slideType: ${slideType}`);
    const url = BaseUrlWeb + 'Home/_FasciaHome';
    const options = { type: 'GET', url, data: { slideType } };

    try {
        return await retryAjax<string>(options);
    } catch (error) {
        console.error('Errore nella chiamata AJAX:', error);
        throw error;
    }
}

/**
 * Carica la fascia home nel contenitore specificato.
 */
async function loadFasciaHome(slideType: string): Promise<void> {
    try {
        const data = await callAjaxFasciaHome(slideType);
        $('#fasciaContainer').html(data);
    } catch (error) {
        console.error('Errore nel caricamento della fascia home:', error);
    }
}

/**
 * Imposta un cookie con il nome, valore e durata specificati.
 */
function setCookie(name: string, value: string, days?: number): void {
    if (!name || !value) {
        console.error('Nome e valore del cookie sono obbligatori.');
        return;
    }

    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

/**
 * Cancella un cookie con il nome specificato.
 */
function eraseCookie(name: string): void {
    if (!name) {
        console.error('Nome del cookie è obbligatorio.');
        return;
    }
    document.cookie = `${name}=; Max-Age=-99999999; path=/`;
}

/**
 * Gestisce il click sulla slide e carica le vendite in evidenza e la fascia home.
 */
function handleSlideClick(type: string): void {
    console.log(`handleSlideClick - type: ${type}`);

    const formImmo = `frmcercahome-${type}`;
    const formMob = `frmcercahomeMOB-${type}`;
    const oppositeType = type === 'business' ? 'privati' : 'business';

    $(`#${formImmo} input[name=SitoChiamante]`).val(type);
    $(`#${formMob} input[name=SitoChiamante]`).val(type);

    eraseCookie(oppositeType);
    setCookie('lastActiveSection', type, 365);

    loadVenditeInEvidenza(type);
    loadFasciaHome(type);
}

/**
 * Inizializza gli event listener per i bottoni di cambio sezione (personale/business).
 */
export function initHomeVenditeEvidenza(): void {
    $('.slideHpNext.personal').on('click', function () {
        handleSlideClick('privati');
    });

    $('.slideHpNext.business').on('click', function () {
        handleSlideClick('business');
    });
}
